import React, { useState, useEffect } from "react";
import { makeStyles, Typography, Grid, Button } from "@material-ui/core/";
import Aux from "../../../../hoc/Auxilliary";
import FormBuilder from "../../../FormBuilder";
import InquiryData from "./InquiryFormData";
import InquiryStyle from "./inquiry.module.css";
import FormHeader from "../../../FormHeader";
import {
  SaveInquiry,
  getInquiryData,
} from "../../../../reduxSlices/applicationSlice";
import { useDispatch, useSelector } from "react-redux";
import { dateValueFormatter } from "../../../../utils/general";
import MessageIndicator from "../../../SnackBar";
import SnackBar from "../../../SnackBar";
import Backdrop from "../../../Backdrop";

import {
  getpreferredContactList,
  getSendInfo,
  getAcademicInterest,
  getFullPartTime,
  getapplicationDetails,
} from "../../../../reduxSlices/applicationSlice";
const useStyle = makeStyles((theme) => ({
  formDesignMain: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
  },
  formContainer: {
    padding: "0.9rem 0.7rem",
    margin: "0",
    background: "#005598",
    display: "flex",
    alignItems: "center",
    color: "#fff",
  },
  formDesign: {
    width: "95%",
    margin: "0 auto",
  },
  formDesign1: {
    width: "97%",
    margin: "0 auto",
  },
}));

var filtterInquiryFormData = {};
let { general, conatactInformation, homeAddress, mailingAddress } = InquiryData;

for (let key in general) {
  filtterInquiryFormData[key] = general[key].value;
}
for (let key in conatactInformation) {
  filtterInquiryFormData[key] = conatactInformation[key].value;
}
for (let key in homeAddress) {
  filtterInquiryFormData[key] = homeAddress[key].value;
}
for (let key in mailingAddress) {
  filtterInquiryFormData[key] = mailingAddress[key].value;
}

const FormItems = (props) => {
  const classes = useStyle(props);
  const dispatch = useDispatch();
  const [jsonData, setJsonData] = useState(filtterInquiryFormData);
  const [InquiryDataSource, setInquiryDataSource] = useState(InquiryData);
  const inquiry = useSelector((state) => state.applicationData.inquiry);
  const [error, setError] = useState({
    isError: false,
    message: "",
    showSnackbar: false,
  });

  const dataFetchingStatus = useSelector(
    (state) => state.applicationData.dataFetchingStatus,
  );
  const [showSnackBar, setShowSnackBar] = useState({
    status: false,
    message: "",
  });
  const [event, setEvent] = useState({
    isEvent: false,
    message: "",
    showSnackbar: false,
  });
  const requestData = useSelector((state) => state.applicationData.requestData);
  const preferredContactList = useSelector(
    (state) => state.applicationData.preferredContactList,
  );
  const sendInfoList = useSelector(
    (state) => state.applicationData.sendInfoList,
  );
  const academicInterestList = useSelector(
    (state) => state.applicationData.academicInterestList,
  );
  const fullPartTimeList = useSelector(
    (state) => state.applicationData.fullPartTimeList,
  );
  const certificationprogram = useSelector(
    (state) => state.applicationData.certificationprogram,
  );

  useEffect(() => {
    dispatch(getInquiryData());
  }, []);

  useEffect(() => {
    const newInquiryDataSource = { ...InquiryDataSource };
    if (inquiry.countries && inquiry.countries.length > 0) {
      const countryList = inquiry.countries.map((country) => {
        return {
          value: country.ses_countryname,
          displayValue: country.ses_countryname,
        };
      });
      const countryList2 = inquiry.countries.map((country) => {
        return {
          value: country.ses_countryname,
          displayValue: country.ses_countryname,
        };
      });
      newInquiryDataSource.mailingAddress.address2_country.elementConfig.options =
        countryList2;
      newInquiryDataSource.homeAddress.address1_country.elementConfig.options =
        countryList;
    }
    setInquiryDataSource(newInquiryDataSource);
    setpreferredContactList();
    setsendInfoList();
    setfullPartTimeList();
    setacademicInterestList();
  }, [inquiry]);

  useEffect(() => {
    dispatch(getapplicationDetails());
  }, []);

  useEffect(() => {
    const newInquiryDataSource = { ...InquiryDataSource };
    if (certificationprogram && certificationprogram?.length > 0) {
      const program = certificationprogram.map((program) => ({
        displayValue: program.ses_certificationprogramname,
        value: program.ses_certificationprogramid,
      }));
      newInquiryDataSource.general._ses_certificationprogram_value.elementConfig.options =
        program;
    }
  }, [certificationprogram]);

  const textFieldChangeHandler = (event) => {
    const filtterFormDataCopy = { ...jsonData };
    filtterFormDataCopy[event.target.name] = event.target.value;
    setJsonData(filtterFormDataCopy);
  };
  const handelChange = (event) => {
    const eventName = event.target.name;
    const filtterFormDataCopy = { ...jsonData };
    filtterFormDataCopy[eventName] = event.target.value;
    setJsonData(filtterFormDataCopy);
  };
  function ValidateEmail(email) {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      return true;
    }
    setEvent({
      isEvent: true,
      message: `You have entered an invalid email address!`,
      showSnackbar: true,
    });
    return;
  }
  function isNumber(n) {
    return /^-?[\d.]+(?:e-?\d+)?$/.test(n);
  }
  useEffect(() => {
    let entity = "lead";
    let attributename = "preferredcontactmethodcode";
    dispatch(getpreferredContactList(entity, attributename));
  }, [dispatch]);

  useEffect(() => {
    let entity = "lead";
    let attributename = "donotsendmm";
    dispatch(getSendInfo(entity, attributename));
  }, [dispatch]);

  useEffect(() => {
    let entity = "lead";
    let attributename = "ses_academicinterest";
    dispatch(getAcademicInterest(entity, attributename));
  }, [dispatch]);

  useEffect(() => {
    let entity = "lead";
    let attributename = "ses_fullparttime";
    dispatch(getFullPartTime(entity, attributename));
  }, [dispatch]);

  const getOptionList = (optionList) => {
    if (Object.keys(optionList)?.length != 0) {
      let transformed = optionList?.map(
        ({ value: displayValue, attributevalue: value }) => ({
          displayValue,
          value,
        }),
      );
      return transformed;
    }
  };

  const setpreferredContactList = () => {
    if (preferredContactList.length != 0) {
      if (Object.keys(preferredContactList)?.length != 0) {
        const transformed = getOptionList(preferredContactList);
        const newInquiryDataSource = { ...InquiryDataSource };
        newInquiryDataSource.conatactInformation.preferredcontactmethodcode.elementConfig.options =
          transformed;
      }
    }
  };

  const setsendInfoList = () => {
    if (sendInfoList.length != 0) {
      if (Object.keys(sendInfoList)?.length != 0) {
        const transformed = getOptionList(sendInfoList);
        const newInquiryDataSource = { ...InquiryDataSource };
        newInquiryDataSource.general.donotsendmm.elementConfig.options =
          transformed;
      }
    }
  };
  const setacademicInterestList = () => {
    if (academicInterestList.length != 0) {
      if (Object.keys(academicInterestList)?.length != 0) {
        const transformed = getOptionList(academicInterestList);
        const newInquiryDataSource = { ...InquiryDataSource };
        newInquiryDataSource.general.ses_academicinterest.elementConfig.options =
          transformed;
      }
    }
  };
  const setfullPartTimeList = () => {
    if (fullPartTimeList.length != 0) {
      if (Object.keys(fullPartTimeList)?.length != 0) {
        const transformed = getOptionList(fullPartTimeList);
        const newInquiryDataSource = { ...InquiryDataSource };
        newInquiryDataSource.general.ses_fullparttime.elementConfig.options =
          transformed;
      }
    }
  };

  const handleSubmit = () => {
    let isValid = true;
    let fieldName = "";

    for (const section in InquiryData) {
      for (const field in InquiryData[section]) {
        if (InquiryData[section][field].elementConfig.required) {
          if (!(jsonData[field] && jsonData[field].trim().length > 0)) {
            fieldName = InquiryData[section][field].elementConfig.label;
            isValid = false;
            break;
          }
        }
        if (!isValid) break;
      }
    }
    if (jsonData?.mobilephone?.length < 10) {
      let value = isNumber(jsonData?.mobilephone);
      setEvent({
        isEvent: true,
        message: `Mobile Phone number max 10 Digits is required`,
        showSnackbar: true,
      });
      return;
    }
    if (jsonData?.telephone1?.length < 10) {
      setEvent({
        isEvent: true,
        message: `Home Phone number max 10 Digits is required`,
        showSnackbar: true,
      });
      return;
    }

    if (jsonData?.mobilephone?.length != "") {
      let value = isNumber(jsonData?.mobilephone);
      if (value === false) {
        setEvent({
          isEvent: true,
          message: `Mobile Phone number should be numbers only`,
          showSnackbar: true,
        });
        return;
      }
    }
    if (jsonData?.telephone1?.length != "") {
      let value = isNumber(jsonData?.telephone1);
      if (value === false) {
        setEvent({
          isEvent: true,
          message: `Home Phone number should be numbers only`,
          showSnackbar: true,
        });
        return;
      }
    }
    if (!isValid) {
      setEvent({
        isEvent: true,
        message: `${fieldName} is required`,
        showSnackbar: true,
      });
      return;
    }

    if (jsonData.emailaddress1 != "") {
      if (
        /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(
          jsonData?.emailaddress1,
        )
      ) {
        dispatch(SaveInquiry(jsonData));
        return;
      } else {
        setEvent({
          isEvent: true,
          message: `You have entered an invalid email address!`,
          showSnackbar: true,
        });
        return;
      }
    }
    dispatch(SaveInquiry(jsonData));
  };

  const handleClearData = () => {
    const newJsonData = { ...jsonData };
    const newInquiryDataSource = { ...InquiryDataSource };
    for (let key in newJsonData) {
      newJsonData[key] = "";
      newJsonData["preferredcontactmethodcode"] = "1";
      newJsonData["ses_birthdate"] = null;
    }
    newInquiryDataSource.conatactInformation.ses_birthdate.value = "";
    setInquiryDataSource(newInquiryDataSource);
    setJsonData(newJsonData);
  };

  const handelDateChange = (event) => {
    const filtterFormDataCopy = { ...jsonData };
    filtterFormDataCopy["ses_birthdate"] = dateValueFormatter(event);
    setJsonData(filtterFormDataCopy);
  };
  useEffect(() => {
    if (requestData) {
      if (requestData?.message === "successful") {
        let status = { ...showSnackBar };
        status.status = true;
        status.message = "successful";
        setShowSnackBar(status);
        handleClearData();
        setTimeout(() => {
          status.status = false;
          setShowSnackBar(status);
        }, 3000);
      }
    }
  }, [requestData]);
  const handleClose = () => {
    if (event.showSnackbar) {
      let eventCopy = { ...event };
      eventCopy.showSnackbar = false;
      setEvent(eventCopy);
    } else {
      let errorCopy = { ...error };
      errorCopy.showSnackbar = false;
      setError(errorCopy);
    }
  };
  return (
    <Aux>
      <SnackBar
        open={showSnackBar.status}
        message={showSnackBar.message}
        handleClose={handleClose}
      />
      <Backdrop show={dataFetchingStatus} />
      <MessageIndicator
        open={event.showSnackbar || error.showSnackbar}
        message={error.message || event.message}
        handleClose={handleClose}
      />
      <Grid container item className={classes.formDesignMain}>
        <Grid
          direction="column"
          container
          item
          className={`${InquiryStyle.mainConatiner} ${InquiryStyle.conatinerWidth}`}
          style={{ alignSelf: "flex-start" }}
        >
          <FormHeader name="General" />
          <div className={classes.formDesign1}>
            <FormBuilder
              formDetails={InquiryDataSource.general}
              value={jsonData}
              changed={(event) => textFieldChangeHandler(event)}
              handelChange={(event) => handelChange(event)}
            />
          </div>
        </Grid>
        <Grid
          className={InquiryStyle.conatinerWidth}
          direction="column"
          container
        >
          <Grid
            direction="column"
            container
            item
            className={InquiryStyle.mainConatiner}
          >
            <FormHeader name="Contact Information" />
            <div className={classes.formDesign}>
              <FormBuilder
                formDetails={InquiryDataSource.conatactInformation}
                value={jsonData}
                changed={(event) => textFieldChangeHandler(event)}
                handelChange={(event) => handelChange(event)}
                handelDateChange={(event) => handelDateChange(event)}
              />
            </div>
          </Grid>
        </Grid>
        <Grid
          className={InquiryStyle.conatinerWidth}
          container
          direction="column"
        >
          <Grid
            direction="column"
            container
            item
            className={InquiryStyle.mainConatiner}
          >
            <FormHeader name="Home Address" />
            <div className={classes.formDesign}>
              <FormBuilder
                formDetails={InquiryDataSource.homeAddress}
                value={jsonData}
                changed={(event) => textFieldChangeHandler(event)}
                handelChange={(event) => handelChange(event)}
              />
            </div>
          </Grid>
          <Grid
            direction="column"
            container
            item
            className={InquiryStyle.mainConatiner}
          >
            <FormHeader name="Mailing Address (If Different)" />
            <div className={classes.formDesign}>
              <FormBuilder
                formDetails={InquiryDataSource.mailingAddress}
                value={jsonData}
                changed={(event) => textFieldChangeHandler(event)}
                handelChange={(event) => handelChange(event)}
              />
            </div>
          </Grid>
        </Grid>
        <Grid container item style={{ marginBottom: "0.6rem" }}>
          <Typography component="div">
            <Button variant="contained" color="primary" onClick={handleSubmit}>
              Submit
            </Button>
            <Button
              variant="outlined"
              color="primary"
              style={{ marginLeft: "0.5rem" }}
              onClick={handleClearData}
            >
              Reset
            </Button>
          </Typography>
        </Grid>
      </Grid>
    </Aux>
  );
};

export default FormItems;
